import type { novaToolDefs } from '@newfront-insurance/ai-api';
import type { InferUITool, ToolUIPart } from 'ai';

import { GeneratedFilesList } from './process-files-tool';

type FormFillingOutput = InferUITool<(typeof novaToolDefs)['formFilling']>['output'];

interface FormFillingToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering formFilling tool output.
 */
export function FormFillingTool({ part }: FormFillingToolProps) {
  if (part.state !== 'output-available') return null;

  const output = part.output as FormFillingOutput;
  if (output?.generatedFiles && output.generatedFiles.length > 0) {
    return (
      <GeneratedFilesList
        files={output.generatedFiles.map((file) => ({ uuid: file.fileUuid, filename: file.filename }))}
      />
    );
  }

  return null;
}
